import { FormMessageType } from '@gn-audio/jss-core/common/enums/form-message.enum';
import { BaseFormMessage } from '@gn-audio/jss-core/common/models';

export type ToastSeverity = 'error' | 'warn' | 'info';

/**
 * Posts a message to the parent window.
 *
 * @template T - The type of the message extending BaseFormMessage.
 * @param message - The message to be posted.
 * @param targetOrigin - The target origin for the message. Defaults to '*', but it is recommended to specify the exact store frontend domain.
 * @returns void
 */
export function postFormMessage<T extends BaseFormMessage>(
  message: T,
  targetOrigin: string = '*'
): void {
  window.parent?.postMessage(message, targetOrigin);
}

/**
 * Posts a toast message to the parent window.
 *
 * @param severity - The severity level of the toast message. Can be 'error', 'warn', or 'info'.
 * @param message - The content of the toast message.
 * @returns void
 */
export function postToastMessage(severity: ToastSeverity, message: string): void {
  const toastMessage = {
    type: FormMessageType.ShowToast,
    toast: { severity, message },
  };
  postFormMessage(toastMessage);
}
